import { render, staticRenderFns } from "./endorse-lobby.vue?vue&type=template&id=7d48e139"
import script from "./endorse-lobby.vue?vue&type=script&lang=js"
export * from "./endorse-lobby.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports